import type { Faq } from './schema'

/** The questions people ask before they write. Pages pick the ones that answer their own objection. */
export const faqs = {
  whatYouBuild: {
    question: 'What do you actually build?',
    answer:
      'Workflows that move work between your tools without manual steps: lead capture and follow-up, CRM updates, email and report generation, content pipelines, and AI agents for support and sales — usually in n8n, Make.com or Zapier, connected to the apps you already use.',
  },
  startSpeed: {
    question: 'How fast can you start?',
    answer:
      'Usually within a few days. I work from Quezon City, Philippines (GMT+8) and overlap well with US and APAC hours. Small automations can go live in the same week; bigger builds start with a short mapping call.',
  },
  needStack: {
    question: 'Do I need a specific platform?',
    answer:
      'No. I work with what you already run — Gmail, Google Sheets, GoHighLevel, Asana, Slack, Airtable — and connect it. If a platform is a poor fit for what you need, I will say so and suggest what works.',
  },
  pricing: {
    question: 'How much do you charge?',
    answer:
      'It depends on scope: how many steps, how many apps, and how much logic is involved. Send me the task you want automated and I reply with a plan and a quote before anything starts.',
  },
  afterWrite: {
    question: 'What happens after I write?',
    answer:
      'I reply within one business day with questions or a short plan — and a straight no if automation is not the right fix.',
  },
} satisfies Record<string, Faq>

export const allFaqs: Faq[] = Object.values(faqs)
